// 组件
import BaseDraggable from './formGenerator/components/BaseDraggable'
import FormGenerator from './formGenerator/index.vue'
import SubForm from './formGenerator/subForm.vue'

// 注册  组件
function install(Vue) {
  Vue.component(BaseDraggable.name, BaseDraggable)
  Vue.component(FormGenerator.name, FormGenerator)
  Vue.component(SubForm.name, SubForm)
}

export default {
  install,
}